const KEYWORDS = {
    curl: ['curl'],
    javascript: ['import', 'from', 'const', 'let', 'var', 'await', 'new', 'function', 'return'],
    php: ['echo'],
    python: ['import', 'with', 'as', 'def'],
};

const FUNCTIONS = {
    php: ['curl_init', 'curl_setopt', 'curl_exec', 'curl_close', 'json_encode', 'file_put_contents'],
    javascript: ['axios', 'writeFileSync', 'log'],
    python: ['get', 'post', 'put', 'delete', 'open', 'print'],
};

const CONSTANTS = {
    php: ['CURLOPT_RETURNTRANSFER', 'CURLOPT_HTTPHEADER', 'CURLOPT_CUSTOMREQUEST', 'CURLOPT_POSTFIELDS'],
};

function escapeRegex(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function buildPattern(language) {
    const parts = [];

    if (language === 'php') parts.push('(?<phpTag><\\?php)');
    parts.push('(?<string>"(?:[^"\\\\]|\\\\.)*"|\'(?:[^\'\\\\]|\\\\.)*\')');
    if (language === 'php') parts.push('(?<variable>\\$[a-zA-Z_]\\w*)');
    parts.push('(?<number>\\b\\d+(?:\\.\\d+)?\\b)');
    parts.push('(?<bool>\\b(?:true|false|True|False|None|null)\\b)');
    if (language === 'curl') parts.push('(?<flag>(?<=\\s)-{1,2}[a-zA-Z][\\w-]*)');

    const constants = CONSTANTS[language];
    if (constants?.length) parts.push(`(?<constant>\\b(?:${constants.map(escapeRegex).join('|')})\\b)`);

    const functions = FUNCTIONS[language];
    if (functions?.length) parts.push(`(?<func>\\b(?:${functions.map(escapeRegex).join('|')})\\b)`);

    const keywords = KEYWORDS[language];
    if (keywords?.length) parts.push(`(?<keyword>\\b(?:${keywords.map(escapeRegex).join('|')})\\b)`);

    if (language === 'json') {
        parts.unshift('(?<jsonKey>"(?:[^"\\\\]|\\\\.)*"(?=\\s*:))');
    }

    return new RegExp(parts.join('|'), 'g');
}

const PATTERN_CACHE = {};

// Tokenise un extrait de code en segments {text, type}, type='plain' si non reconnu.
// Volontairement simple : le vocabulaire couvert correspond exactement à ce que
// les templates de src/Utils/apiSnippets.js génèrent (pas un vrai parseur de langage).
export function highlightTokens(code, language) {
    if (!code || language === 'text' || !language) return [{text: code || '', type: 'plain'}];

    if (!PATTERN_CACHE[language]) PATTERN_CACHE[language] = buildPattern(language);
    const pattern = PATTERN_CACHE[language];
    pattern.lastIndex = 0;

    const tokens = [];
    let lastIndex = 0;
    let match;
    while ((match = pattern.exec(code)) !== null) {
        const groups = match.groups;
        if (match.index > lastIndex) tokens.push({text: code.slice(lastIndex, match.index), type: 'plain'});
        const type = Object.keys(groups).find((key) => groups[key] !== undefined) || 'plain';
        tokens.push({text: match[0], type});
        lastIndex = match.index + match[0].length;
    }
    if (lastIndex < code.length) tokens.push({text: code.slice(lastIndex), type: 'plain'});

    return tokens;
}
